module.exports = __webpack_public_path__ + "static/media/dcsg1.297e3729.jpg";